var React = require('react');

function WestfieldDirectReturnsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"westfield-direct-returns-24px@1x-a","d":"M7.854 12.146l-1.415 1.415-5-5a1 1 0 010-1.415l5-5 1.415 1.415-3.44 3.438L16 7a7 7 0 016.996 6.76L23 14a7 7 0 01-7 7H2v-2h14a5 5 0 000-10H4.706l3.148 3.146z"}));
}

WestfieldDirectReturnsInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = WestfieldDirectReturnsInline;

WestfieldDirectReturnsInline.default = WestfieldDirectReturnsInline;
